import React, { useState, useEffect } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Identity } from '@wajeez-web/core/api-base';
import { TeamActions, useRolesDispatch } from '@wajeez-web/stores/roles';
import { TextInput, SwitchInput, Button } from '@wajeez-web/components/ui';
const EditUserModal: React.FC<CommonModalProps<Identity.UserDetailsOutput>> = ({
  isOpen,
  onClose,
  data,
}) => {
  const [changeSelectUserPassword, setChangeSelectedUserPassword] =
    useState(false);
  const [password, setPassword] = useState('');
  const dispatch = useRolesDispatch();
  const [selectedUserData, setSelectedUserData] =
    useState<Identity.UserDetailsOutput>({
      id: '',
      name: '',
      email: '',
      isVerified: true,
      gender: 0,
      isBlocked: false,
    });

  useEffect(() => {
    if (data) {
      setSelectedUserData({
        ...data,
      });
    }
  }, [data]);

  const OnUserChange = (name: string, val: any) => {
    setSelectedUserData({ ...selectedUserData, [name]: val });
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Update user"
      withScroll={true}
    >
      <div className=" space-y-5">
        <div className={`grid grid-cols-${2} gap-3 `}>
          <div className={`md:col-span-${2} col-span-${2}`}>
            <TextInput
              value={selectedUserData.email}
              label={'Email'}
              name={'email'}
              onChange={OnUserChange}
            />
          </div>

          <div className={`md:col-span-${2} col-span-${2}`}>
            <SwitchInput
              value={selectedUserData.isVerified}
              label={'Is Verified'}
              name={'isVerified'}
              onChange={OnUserChange}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <Button
            title={'change'}
            bg={'primary'}
            color={'white'}
            onClick={() => {
              dispatch(
                TeamActions.setUserEmailAsync({
                  userId: selectedUserData.id,
                  email: selectedUserData.email || '',
                  isVerified: selectedUserData.isVerified || false,
                })
              );
            }}
          />
        </div>
        <div className="w-full h-0.5 rounded bg-gray-100"></div>
        <div>
          {!changeSelectUserPassword && (
            <p className=" text-textSecondary">
              Do you want to change user password?
              <span
                onClick={() => setChangeSelectedUserPassword(true)}
                className=" text-primary cursor-pointer"
              >
                {' '}
                yes
              </span>
            </p>
          )}

          {changeSelectUserPassword && (
            <div className=" space-y-5">
              <div className={`grid grid-cols-${2} gap-3 `}>
                <div className={`md:col-span-${2} col-span-${2}`}>
                  <TextInput
                    value={password}
                    label={'Password'}
                    name={'password'}
                    onChange={(name, val) => setPassword(val)}
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <Button
                  title={'change'}
                  bg={'primary'}
                  color={'white'}
                  onClick={() => {
                    dispatch(
                      TeamActions.setUserPasswordAsync({
                        userId: selectedUserData.id,
                        password: password || '',
                      })
                    );
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EditUserModal;
